import { apiSlice } from './apiSlice';
import { BRANDS_URL } from '../constants';

export const brandApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getBrands: builder.query({
            query: (params = {}) => ({
                url: BRANDS_URL,
                params,
            }),
            providesTags: ['Brand'],
        }),
        getBrandById: builder.query({
            query: (id) => `${BRANDS_URL}/${id}`,
            providesTags: (_result, _error, id) => [{ type: 'Brand', id }],
        }),
        createBrand: builder.mutation({
            query: (data) => ({
                url: BRANDS_URL,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Brand'],
        }),
        updateBrand: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `${BRANDS_URL}/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Brand'],
        }),
        deleteBrand: builder.mutation({
            query: (id) => ({
                url: `${BRANDS_URL}/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Brand'],
        }),
    }),
});

export const {
    useGetBrandsQuery,
    useGetBrandByIdQuery,
    useCreateBrandMutation,
    useUpdateBrandMutation,
    useDeleteBrandMutation,
} = brandApiSlice;

